module.exports = __webpack_public_path__ + "img/green-valley.56e14d57.png";